require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./addons-writing-addons.json") })
        }
      }, "path---addons-writing-addons");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---addons-writing-addons!./.cache/json/addons-writing-addons.json
// module id = 397
// module chunks = 231608221292675